import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Area } from '../../core/constants/area';
import { SetQueueItemModel } from './notification-queue/models/SetQueueItemModel';

@Injectable()
export class QueueService {

  constructor(public httpClient: HttpClient) { }
  getQueueItemCount(){
    const url = `${environment.dotNetApiUrl}/${Area.core}/Queue/Item/Count`;
    return this.httpClient.get<any[]>(url);
  }
  getQueueResultErrorCount(){
    const url = `${environment.dotNetApiUrl}/${Area.core}/Queue/Error/Count`;
    return this.httpClient.get<any[]>(url);
  }
  getQueueResendCutoffHours(){
    const url = `${environment.dotNetApiUrl}/${Area.core}/Queue/ResendCutoff`;
    return this.httpClient.get<any[]>(url);
  }
  getQueueItemList(divisionId: number){
    const url = `${environment.dotNetApiUrl}/${Area.core}/Queue/Item/List?divisionId=${divisionId}`;
    return this.httpClient.get<any[]>(url);
  }
  getQueueResultList(isApproved: boolean, startDate: string, endDate: string, divisionId: number){
    const url = `${environment.dotNetApiUrl}/${Area.core}/Queue/Result/List?isApproved=${isApproved}&startDate=${startDate}&endDate=${endDate}&divisionId=${divisionId}`;
    return this.httpClient.get<any[]>(url);
  }
  setQueueItem(model: SetQueueItemModel) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Queue/Item`;
    return this.httpClient.post<any[]>(url, model);
  }
  rejectQueueItemBatch(queueItemIds: number[]){
    const url = `${environment.dotNetApiUrl}/${Area.core}/Queue/Item/Reject/Batch`;
    return this.httpClient.post<any[]>(url, queueItemIds);
  }
  approveQueueItemBatch(queueItemIds: number[]){
    const url = `${environment.dotNetApiUrl}/${Area.core}/Queue/Item/Approve/Batch`;
    return this.httpClient.post<any[]>(url, queueItemIds);
  }
  resendQueueItemBatch(queueResultIds: number[]){
    const url = `${environment.dotNetApiUrl}/${Area.core}/Queue/Result/Resend/Batch`;
    return this.httpClient.post<any[]>(url, queueResultIds);
  }
  patchIsErrorCleared(queueResultId: number, isCleared: boolean) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Queue/IsErrorCleared?queueResultId=${queueResultId}&isCleared=${isCleared}`;
    return this.httpClient.patch<any[]>(url, {});
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/notifications/queue.service.ts